import { useEffect, useState } from "react"

function detectFlagEmojiSupport(): boolean {
	const canvas = document.createElement("canvas")
	canvas.width = canvas.height = 1
	const ctx = canvas.getContext("2d")
	if (!ctx) return false
	ctx.fillText("🇬🇧", -4, 4)
	return ctx.getImageData(0, 0, 1, 1).data[3] > 0
}

export default function useFlagEmojiSupport(): boolean {
	const [isSupported, setSupported] = useState(false)

	useEffect(() => {
		setSupported(detectFlagEmojiSupport())
	}, [])

	return isSupported
}
